const checkoutTranslations = {
    en: {
        // Top navigation
        "Login": "Login",
        "Shipping": "Shipping",
        "Overview": "Overview",
        "Payment": "Payment",
        "Profile": "Profile",
        "Orders": "Orders",
        "Order": "Order",
        "Addresses": "Addresses",
    
        // Titles Checkout
        titleLogin: "What is your email address?",
        titleDataShippingChoice: "Deliver or collect your order?",
        titleDataDelivery: "Where can we deliver your parcel?",
        titleDataCollect: "In which store do you want to collect?",
        titleDataCollectSub: "We will send you an email when your order is ready for collection.",
        titleDataBilling: "What is the billing address?",
        titleEditAddressModal: "Edit address",
        titleOverview: "Overview of your order",
        titleVoucher: "Voucher or coupon code",
        titleThanks: "Thanks for your order!",
        titleThanksSub: "Thank you very much for your order, we will get to work for you.<br>You will soon receive an e-mail with the overview of your order.",
        thanksInfo: "<strong>Attention!</strong><br>In case you ordered a product with a custom writing or drawing, don't forget to mail the corresponding template to <a href='mailto:atelier@elisalee.be' class='underline'>atelier@elisalee.be</a>.",
        titleEmptyCart: "It looks like your cart is empty",
        titleProfile: "Profile",
        titleAddresses: "My addresses",
        titleOrders: "My orders",
        titlePasswordReset: "Password reset",
        
        // Titles Account dashboard
        titleAccountLogin: "Login",
        
        // Labels
        labels: {
            email: "Email address",
            password: "Password",
            attention: "Attention",
            title: "Title",
            firstName: "First name",
            lastName: "Last name",
            fullName: "Name",
            address1: "Street",
            address2: "Nr.",
            address3: "Mailbox",
            zipCode: "ZIP code",
            city: "City",
            phone: "Phone",
            alternativePhone: "Alternative phone",
            label: "Label",
            notes: "Notes",
            businessName: "Business name",
            businessTaxId: "Business Tax ID",
            businessId: "Business ID",
            countryId: "Country",
            stateValue: "State",
            custom1: "custom1",
            custom2: "custom2",
            custom3: "custom3",
            custom4: "custom4",
            shippingAddress: "Shipping address",
            billingAddress: "Billing address",
            currentPassword: "Current password",
            newPassword: "New password"
        },
        
        // Placeholders
        placeholders: {
            email: "john@gmail.com"
        },
        
        // Validation
        validation: {
            general: "Please fill in all fields.",
            required: "This field is required",
            email: "E-mail is not valid"
        },
        
        // Notifications
        notifications: {
            "Sorry": "Sorry",
            "Something went wrong, please try again later.": "Something went wrong, please try again.",
            "Payment not succeeded": "Payment not succeeded",
            "There was an error returned by the payment gateway Mollie.": "There was an error returned by the payment gateway Mollie.",
            "You must accept our terms and conditions and privacy policy.": "You must accept our terms and conditions and privacy policy.",
            "We cannot visualise your cart, but it is still here!": "We cannot visualise your cart, but it is still here!",
            "Profile saved": "Profile saved",
            "Password reset e-mail send.": "Password reset e-mail send."
        },
        
        // Product option keys
        "Afwerking": "Finish",
        "Materiaal": "Material",
        "Eindafwerking": "Final finish",
        "Maat": "Size",
        "Extra opties": "Extra options",
        "Lettertype": "Font style",
        "Aantal woorden": "The number of words",
        "Aantal letters": "The number of letters",
        "Aantal gravure zijdes": "The number of engraving sides",
        "Steker": "Plug",
        "Type": "Type",
        "Diamant kleur en kwaliteit": "Diamond color and quality",
        "Kleine diamant kleur en kwaliteit": "Small diamond color and quality",
        "Edelsteen": "Gemstone",
        "Grootte": "Size",
        "Ringmaat": "Ring size",
        
        // Other
        "new": "new",
        "Prototype": "Prototype",
        "Subtotal": "Subtotal",
        "Delivery": "Delivery",
        "Total discount": "Total discount",
        "Total VAT incl.": "Total VAT incl.",
        "Having problems? Contact us": "Having problems? Contact us",
        "Forgot password?": "Forgot password?",
        "Show": "Show",
        "Hide": "Hide",
        "Next": "Next",
        "Back": "Back",
        "Logging in": "Logging in",
        "Saving": "Saving",
        "Bezorgen": "Delivery",
        "Afhalen": "Collect",
        deliveryNote: "At home or at another address",
        collectNote: "Pick up your order in one of the stores",
        "Edit": "Edit",
        "Logout": "Logout",
        addAddress: "Add a new address",
        "Delete": "Delete",
        "Save": "Save",
        "Select a country": "Select a country",
        primeDelivery: "Make this the primary delivery address",
        isPrimeDelivery: "Primary delivery address",
        primeBilling: "Make this the primary billing address",
        isPrimeBilling: "Primary billing address",
        "Same as shipping address": "Same as shipping address",
        newsletterDescription: "Yes, I wish to subscribe to the newsletter",
        klaviyoDisclaimer: "We use Klaviyo as our marketing platform. By clicking below to proceed, you acknowledge that your information will be transferred to Klaviyo for processing.",
        mailchimpDisclaimer: "We use Mailchimp as our marketing platform. By clicking below to proceed, you acknowledge that your information will be transferred to Mailchimp for processing. <a href='https://mailchimp.com/legal' target='_blank'>Learn more about Mailchimp's privacy practices here.</a>",
        privacyDisclaimer: "By placing this order I agree to the <a href='http://elisalee.the-craft.be/en/terms-conditions' target='_blank'>terms and conditions</a> and the <a href='http://elisalee.the-craft.be/en/privacy-policy' target='_blank'>privacy policy</a> of Elisa Lee",
        newAccountCreation: "Yes, I wish to create an account",
        payBtn: "Continue to payment",
        "Back to the homepage": "Back to the homepage",
        fillYourCart: "Go ahead and fill your cart!",
        "View order": "View order",
        "Giftcard": "Giftcard",
        "Digitaal": "Digital",
        "Papier": "Paper",
        "Finished": "Finished",
        "Processing": "Processing",
        "Info": "Info",
        "Total": "Total",
        "Paid": "Paid",
        "Date": "Date",
        "Shippingmethod": "Shippingmethod",
        "Pick-up location": "Pick-up location",
        "Order not found": "Order not found",
        "No orders found": "No orders found",
        "Code": "Code",
        "Codes": "Codes",
        "Download voucher as PDF": "Download voucher as PDF",
        "valid until": "valid until",
        "Loading order...": "Loading order...",
        "Loading orders...": "Loading orders...",
        "Reset password": "Reset password",
        "Sending": "Sending",
        "Coupon code": "Coupon code",
        
        // Verbb giftvoucher errors
        "Voucher code is not valid": "Voucher code is not valid.",
        "No voucher code provided.": "No voucher code provided.",
        "Code deleted": "Code deleted",
        "Could not delete code.": "Could not delete code.",
        "Uw opmerking": "Your remarks",
        "Uw bijgevoegde bestanden": "Your attached files"
    },
    nl: {
        // Top navigation
        "Login": "Inloggen",
        "Shipping": "Gegevens",
        "Overview": "Overzicht",
        "Payment": "Betalen",
        "Profile": "Profiel",
        "Orders": "Bestellingen",
        "Order": "Bestelling",
        "Addresses": "Adressen",
    
        // Titles
        titleLogin: "Wat is je e-mailadres?",
        titleDataShippingChoice: "Je bestelling verzenden of afhalen?",
        titleDataDelivery: "Waar mogen we je pakje leveren?",
        titleDataCollect: "In welke winkel wil je afhalen?",
        titleDataCollectSub: "We sturen je een e-mail als je bestelling klaarligt voor afhaling.",
        titleDataBilling: "Wat is het factuuradres?",
        titleEditAddressModal: "Adres aanpassen",
        titleOverview: "Overzicht van je bestelling",
        titleVoucher: "Geschenkbon- of couponcode",
        titleThanks: "Bedankt voor je bestelling!",
        titleThanksSub: "Hartelijk bedankt voor je bestelling, we gaan voor jou aan de slag.<br>Je ontvangt weldra een e-mail met het overzicht van je bestelling.",
        thanksInfo: "<strong>Belangrijk!</strong><br>In het geval je een product bestelde met een vrije tekst of tekening gravure, vergeet je template niet naar <a href='mailto:atelier@elisalee.be' class='underline'>atelier@elisalee.be</a> te sturen.",
        titleEmptyCart: "Jouw mandje is nog leeg",
        titleProfile: "Profiel",
        titleAddresses: "Mijn adressen",
        titleOrders: "Mijn bestellingen",
        titlePasswordReset: "Paswoord opnieuw instellen",
    
        // Titles Account dashboard
        titleAccountLogin: "Inloggen",
        
        // Labels
        labels: {
            email: "E-mailadres",
            password: "Wachtwoord",
            attention: "Aanspreking",
            title: "Titel",
            firstName: "Voornaam",
            lastName: "Familienaam",
            fullName: "Naam",
            address1: "Straat",
            address2: "Nr.",
            address3: "Postbus",
            zipCode: "Postcode",
            city: "Stad",
            phone: "Telefoon",
            alternativePhone: "Mobiele telefoon",
            label: "Label",
            notes: "Notities",
            businessName: "Bedrijfsnaam",
            businessTaxId: "BTW nummer",
            businessId: "Bedrijfs nummer",
            countryId: "Land",
            stateValue: "Provincie",
            custom1: "custom1",
            custom2: "custom2",
            custom3: "custom3",
            custom4: "custom4",
            shippingAddress: "Bezorgadres",
            billingAddress: "Factuuradres",
            currentPassword: "Huidig paswoord",
            newPassword: "Nieuw paswoord"
        },
    
        // Placeholders
        placeholders: {
            email: "els@gmail.com"
        },
    
        // Validation
        validation: {
            general: "Vul alle velden in, aub.",
            required: "Dit veld is verplicht",
            email: "Ongeldig e-mail adres"
        },
    
        // Notifications
        notifications: {
            "Sorry": "Excuses",
            "Something went wrong, please try again later.": "Er ging iets mis, probeer opnieuw.",
            "Payment not succeeded": "De betaling is mislukt",
            "There was an error returned by the payment gateway Mollie.": "Er is een fout opgetreden in de betalingsgateway Mollie.",
            "You must accept our terms and conditions and privacy policy.": "U dient onze algemene voorwaarden en privacybeleid te accepteren.",
            "We cannot visualise your cart, but it is still here!": "We kunnen uw winkelmandje niet visualiseren, maar het is er nog steeds!",
            "Profiel bewaard": "Profiel bewaard",
            "Password reset e-mail send.": "Paswoord opnieuw instellen e-mail verstuurd."
        },
    
        // Product option keys
        "Afwerking": "Afwerking",
        "Materiaal": "Materiaal",
        "Eindafwerking": "Eindafwerking",
        "Maat": "Maat",
        "Extra opties": "Extra opties",
        "Lettertype": "Lettertype",
        "Aantal woorden": "Aantal woorden",
        "Aantal letters": "Aantal letters",
        "Aantal gravure zijdes": "Aantal gravure zijdes",
        "Steker": "Steker",
        "Type": "Type",
        "Diamant kleur en kwaliteit": "Diamant kleur en kwaliteit",
        "Kleine diamant kleur en kwaliteit": "Kleine diamant kleur en kwaliteit",
        "Edelsteen": "Edelsteen",
        "Grootte": "Grootte",
        "Ringmaat": "Ringmaat",
    
        // Other
        "new": "new",
        "Prototype": "Prototype",
        "Subtotal": "Subtotaal",
        "Delivery": "Verzending",
        "Total discount": "Totale korting",
        "Total VAT incl.": "Totaal incl. BTW",
        "Having problems? Contact us": "Problemen ? Contacteer ons",
        "Forgot password?": "Wachtwoord vergeten?",
        "Show": "Toon",
        "Hide": "Verberg",
        "Next": "Ga verder",
        "Back": "Terug",
        "Logging in": "Inloggen",
        "Saving": "Bewaren",
        "Bezorgen": "Bezorgen",
        "Afhalen": "Afhalen",
        deliveryNote: "Thuis of op een ander adres",
        collectNote: "Haal je bestelling op in een van de winkels",
        "Edit": "Wijzigen",
        "Logout": "Uitloggen",
        addAddress: "Voeg een nieuw adres toe",
        "Delete": "Verwijderen",
        "Save": "Bewaren",
        "Select a country": "Selecteer een land",
        primeDelivery: "Maak dit het primaire leveradres",
        isPrimeDelivery: "Primaire leveradres",
        primeBilling: "Maak dit het primaire factuuradres",
        isPrimeBilling: "Primaire factuuradres",
        "Same as shipping address": "Hetzelfde als het verzendingsadres",
        newsletterDescription: "Ja, ik wens mij in te schrijven op de nieuwsbrief",
        klaviyoDisclaimer: "Wij gebruiken Klaviyo als ons marketing platform. Door onderaan te klikken op ga verder, erkent U dat uw informatie wordt overgedragen aan Klaviyo voor verwerking.",
        mailchimpDisclaimer: "Wij gebruiken Mailchimp als ons marketing platform. Door onderaan te klikken op ga verder, erkent U dat uw informatie wordt overgedragen aan Mailchimp voor verwerking. <a href='https://mailchimp.com/legal' target='_blank'>Lees hier meer over de privacypraktijken van Mailchimp.</a>",
        privacyDisclaimer: "Door het plaatsen van deze bestelling ga ik akkoord met de <a href='http://elisalee.the-craft.be/algemene-voorwaarden' target='_blank'>algemene voorwaarden</a> en het <a href='http://elisalee.the-craft.be/privacy-policy' target='_blank'>privacybeleid</a> van Elisa Lee",
        newAccountCreation: "Ja, ik wens een account aan te maken",
        payBtn: "Ga verder naar betalen",
        "Back to the homepage": "Terug naar de homepagina",
        fillYourCart: "Vul snel je mandje!",
        "View order": "Bekijk bestelling",
        "Giftcard": "Giftcard",
        "Digitaal": "Digitaal",
        "Papier": "Papier",
        "Finished": "Afgehandeld",
        "Processing": "In behandeling",
        "Info": "Info",
        "Total": "Totaal",
        "Paid": "Betaald",
        "Date": "Datum",
        "Shippingmethod": "Verzendingsmethode",
        "Pick-up location": "Afhaal locatie",
        "Order not found": "Bestelling niet gevonden",
        "No orders found": "Geen Bestellingen gevonden",
        "Code": "Code",
        "Codes": "Codes",
        "Download voucher as PDF": "Download voucher als PDF",
        "valid until": "geldig tot",
        "Loading order...": "Bestelling laden...",
        "Loading orders...": "Bestellingen laden...",
        "Reset password": "Stel paswoord opnieuw in",
        "Sending": "Versturen",
        "Coupon code": "Coupon code",
    
        // Verbb giftvoucher
        "Discount applied!": "Korting toegepast!",
        "Voucher code is not valid": "Deze code is niet geldig.",
        "No voucher code provided.": "Geen code ingevuld.",
        "Code deleted": "Code verwijderd",
        "Could not delete code.": "Kon code niet verwijderen.",
        "Uw opmerking": "Uw opmerking",
        "Uw bijgevoegde bestanden": "Uw bijgevoegde bestanden"
    }
}

export default checkoutTranslations;
